export { default } from './TrailStandardCardShimmer';
